module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Islisberg_AG-ea4909e7479ff969a3f7a1d393cdecb2.svg";